import React, { useState } from "react"
import { InputReason, OrderCompensation } from "lib/types/generated/graphql-types"
import { useMutation } from "@apollo/client"
import UPDATE_COMPENSATION from "../../../../../graphql/mutations/order/compensation/UpdateCompensation"
import { getCompensationInput } from "../Helpers/helpers"
import { handleErrorMessages } from "helpers/errors"
import Reason from "../../Reason/Reason"
import { ReasonType } from "lib/types/order"
import { isSkipReason } from "../../../helpers"

type Props = {
  compensation: OrderCompensation
  refetch: () => void
  orderLoading: boolean
}

const CompensationReason = ({ compensation, refetch, orderLoading }: Props) => {
  const [reasonType, setReasonType] = useState<ReasonType | undefined>(
    !compensation.reason ? ReasonType.SKIP : undefined
  )
  const [updateCompensation, { loading }] = useMutation(UPDATE_COMPENSATION, {
    onCompleted: () => refetch(),
    onError: (error) => {
      handleErrorMessages(error)
    }
  })

  const addReason = (reason: InputReason) => {
    updateCompensation({
      variables: {
        compensationId: compensation.id,
        input: {
          ...getCompensationInput(compensation),
          ...(reason.cause && reason.code && !isSkipReason(reasonType) && { reason: reason })
        }
      }
    })
  }

  const removeReason = () => {
    updateCompensation({
      variables: {
        compensationId: compensation.id,
        input: {
          ...getCompensationInput(compensation),
          reason: null
        }
      }
    }).then(() => setReasonType(ReasonType.SKIP))
  }

  return (
    <Reason
      orderReason={compensation.reason}
      reasonType={reasonType}
      setReasonType={setReasonType}
      removeReason={removeReason}
      addReason={addReason}
      loading={loading}
      orderLoading={orderLoading}
    />
  )
}

export default CompensationReason
